/// <reference path="./_references.ts"/>

module App.Administrative {
    declare const Chart: any;

    import Appointment = App.Appointments.Appointment;
    import BottomDrawerService = App.Helpers.BottomDrawerService;
    import InventoryService = App.Administrative.Inventory.InventoryService;
    import LoginService = App.Login.LoginService;
    import PurchaseOrderService = App.Administrative.PurchaseOrder.PurchaseOrderService;
    import SelectedAppointment = App.Appointments.SelectedAppointment;
    import ToastService = App.Utils.ToastService;
    import userLoginData = App.Login.userLoginData;

    export class AdministrativeController {
        note: string = "";
        showMdl: boolean = false;
        appointment: Appointment = null;

        loading: boolean = true;
        isSaving: boolean = false;
        isNoteSaving: boolean = false;
        gameOn: boolean = false;
        gameConfig: GameConfig = null;
        appointmentChecklist: AppointmentChecklist = null;
        serviceRequestChecklist: ServiceRequestChecklist = null;
        completeForm: ng.IFormController;
        userData: userLoginData = this.LoginService.giveUserData();

        private poStatus?: string = null;
        private poLoading: boolean = false;
        private replenishmentStatus?: string = null;
        private replenishmentLoading: boolean = false;
        private vendorInventoryReplenishmentStatus?: string = null;
        private vendorInventoryReplenishmentLoading: boolean = false;

        static $inject: string[] = [
            '$state', '$timeout', '$q', 'PermissionService', 'SelectedAppointment', 'AdministrativeService', 'InventoryService',
            'VendorInventoryService', 'PurchaseOrderService', 'TimeEventService', 'LoginService', 'ToastService', 'ModalService',
            'BottomDrawerService'
        ];

        constructor(
            protected $state: ng.ui.IStateService,
            protected $timeout: ng.ITimeoutService,
            public $q: ng.IQService,
            protected PermissionService: App.Helpers.PermissionService,
            protected SelectedAppointment: SelectedAppointment,
            protected AdministrativeService: AdministrativeService,
            protected InventoryService: InventoryService,
            protected VendorInventoryService: App.Administrative.VendorInventory.VendorInventoryService,
            protected PurchaseOrderService: PurchaseOrderService,
            protected TimeEventService: App.TimeEvent.TimeEventService,
            protected LoginService: LoginService,
            protected ToastService: ToastService,
            protected ModalService: any,
            protected BottomDrawerService: BottomDrawerService
        ) {
            SelectedAppointment.getAppointment().then((appointment) => {
                this.setAppointment(appointment);
            });
        }

        completeAppointment() {
            const vm = this,
                apptId = vm.SelectedAppointment.id;

            vm.isSaving = true;
            const completeApp = () => {
                vm.SelectedAppointment.updateAppointmentStatus('Completed Appointment', true)
                    .then(() =>
                        this.TimeEventService.confirmLastEvent().then(() => {
                            if (vm.SelectedAppointment.getPhone(true, true) !== "No phone found") {
                                vm.sendCustomerText('Completed');
                            } else {
                                vm.SelectedAppointment.clear();
                                vm.$state.go('zipSolutions.home.appointment', {completedApptId: apptId});
                            }
                        })
                    )
                    .catch((response) => {
                        vm.ToastService.showError('Unable to complete appointment: ', response);
                        vm.isSaving = false;
                    });
            }, showGamification = () => {
                const promises = {
                    srScore: vm.AdministrativeService.getSRscore(vm.appointment.service_request.id, { show_targets: 1 }),
                    techScore: vm.AdministrativeService.getTechScore()
                };

                vm.$q.all(promises).then((response) => {
                    var modalOptions = {
                        templateUrl: "html/administrative/gamification.html",
                        controller: function(close: (link: boolean) => void) {
                            this.save = function(save: boolean) {
                                close(save);
                            };
                            this.srScore = response.srScore.data;
                            this.techScore = response.techScore.data;
                            this.gameConfig = vm.gameConfig;
                            this.lastName = vm.userData.last_name;
                            this.appointment = vm.appointment;

                            let dates = Array(14).fill(0).map((_, i) => moment().subtract(i, 'days')).reverse(),
                                dateKeys = dates.map((d) => d.format('YYYY-MM-DD')),
                                data = dateKeys.map((d) => response.techScore.data.data[d] || null),
                                series = ['Your Score'],
                                dataOptions = [{
                                    backgroundColor: '#21ce99',
                                    borderColor: '#21ce99',
                                }],
                                dataVal = [data];

                            if (Object.keys(response.techScore.data.team_data || {}).length) {
                                let color = Chart.defaults.global.colors[0];

                                dataVal.push(dateKeys.map((d) => response.techScore.data.team_data[d] || null));
                                dataOptions.push({
                                    backgroundColor: color,
                                    borderColor: color,
                                });
                                series.push('Your Team');
                            }

                            if (Object.keys(response.techScore.data.all_data || {}).length) {
                                let color = Chart.defaults.global.colors[1];

                                dataVal.push(dateKeys.map((d) => response.techScore.data.all_data[d] || null));
                                dataOptions.push({
                                    backgroundColor: color,
                                    borderColor: color,
                                });
                                series.push('All Techs');
                            }

                            this.chart = {
                                labels: dates.map((d) => d.format('MMM DD')),
                                data: dataVal,
                                series: series,
                                dataOptions: dataOptions,
                                options: {
                                    tooltips: {
                                        callbacks: {
                                            label: (tooltip: {datasetIndex: number, yLabel: number}, data: {datasets: {label: string}[]}) => {
                                                return isNaN(tooltip.yLabel)
                                                    ? ''
                                                    : ' ' + data.datasets[tooltip.datasetIndex].label + ': ' + tooltip.yLabel;
                                            }
                                        }
                                    },
                                    scales: {
                                        yAxes: [{
                                            ticks: {
                                                min: 0,
                                                max: 100,
                                            },
                                        }],
                                    },
                                },
                            };
                        },
                        controllerAs: 'ctrl',
                        backdrop: 'static',
                        keyboard: true
                    };
                    modalOptions.controller.$inject = ['close'];
                    vm.ModalService.showModal(modalOptions).then((modal: any) => {
                        modal.close.then((save: boolean) => {
                            if(save) {
                                completeApp();
                            } else {
                                vm.isSaving = false;
                            }
                        });
                    });
                });
            };

            if(vm.note !== "") {
                vm.AdministrativeService.CreateServiceRequestNote(vm.appointment.service_request.id, vm.note).then(() => {
                    vm.gameOn ? showGamification() : completeApp();
                });
            } else {
                vm.gameOn ? showGamification() : completeApp();
            }
        }

        saveNote() {
            const vm = this;

            vm.isNoteSaving = true;
            vm.AdministrativeService.CreateServiceRequestNote(vm.appointment.service_request.id, vm.note)
                .then((resp) => {
                    vm.ToastService.show('Note Saved');
                    vm.note = '';
                    vm.completeForm.$setPristine();
                    vm.completeForm.$setUntouched();
                    vm.appointment.service_request.notes.unshift(resp.data);
                }).catch((response) => {
                    vm.ToastService.showError('Unable to save note: ', response);
                }).finally(() => {
                    vm.isNoteSaving = false;
                });
        }

        sendCustomerText(nextStatus: string) {
            const vm = this,
                apptId = vm.SelectedAppointment.id;

            vm.BottomDrawerService.open([
                {
                    text: "Send text",
                    icon: 'fas fa-mobile-alt fa-fw',
                    fn: () => {
                        vm.SelectedAppointment.sendCustomerText(nextStatus);
                        vm.SelectedAppointment.clear();
                        vm.$state.go('zipSolutions.home.appointment', {completedApptId: apptId});
                    }
                },
                {
                    text: "Do not send a text",
                    icon: 'fas fa-times fa-fw',
                    fn: () => {
                        vm.SelectedAppointment.clear();
                        vm.$state.go('zipSolutions.home.appointment', {completedApptId: apptId});
                    }
                }
            ], true, false);
        }

        isRequired(item: AppointmentCheckListItem) {
            if(!item.required) return false;
            let vm = this,
                role = vm.userData.role;

            return (role && role.id === 2) ||
                vm.userData.permissions.indexOf(item.permission) !== -1;
        }

        getGamification() {
            const vm = this;

            vm.AdministrativeService.getGameConfig().then((resp) => {
                vm.gameOn = resp.data.visible;
                vm.gameConfig = resp.data;
            });
        }

        getChecklists() {
            const vm = this;

            const promises = {
                appointmentChecklist: vm.AdministrativeService.GetAppointmentChecklist(vm.appointment.id),
                srChecklist: vm.AdministrativeService.GetServiceRequestChecklist(vm.appointment.service_request.id)
            };

            vm.$q.all(promises).then((response) => {
                vm.appointmentChecklist = response.appointmentChecklist.data;
                for(let idx in vm.appointmentItems) {
                    const item = vm.appointmentItems[idx];
                    item.isSelected = <boolean>vm.appointmentChecklist[item.name];
                }
                vm.serviceRequestChecklist = response.srChecklist.data;
                for(let idx in vm.serviceRequestItems) {
                    const item = vm.serviceRequestItems[idx];
                    item.isSelected = <boolean>vm.serviceRequestChecklist[item.name];
                }
                vm.upgradeMdlInputs();
                vm.loading = false;
            });
        }

        updateAppointment(item: CheckListItem) {
            const vm = this;

            item.isSelected = !item.isSelected;
            vm.appointmentChecklist[item.name] = item.isSelected;
            vm.AdministrativeService.UpdateAppointmentChecklist(vm.appointment.id, vm.appointmentChecklist);
        }

        updateServiceRequest(item: CheckListItem) {
            const vm = this;

            vm.serviceRequestChecklist[item.name] = item.isSelected;
            vm.AdministrativeService.UpdateServiceRequestChecklist(vm.appointment.service_request.id, vm.serviceRequestChecklist);
        }

        appointmentItems: AppointmentCheckListItem[] = [
            {
                displayName: 'Email Recommendations',
                name: 'email_recommendations',
                status: () => "",
                sref: 'zipSolutions.history.recommendations.detail',
                permission: 'web.field.administrative.email-recommendations',
                required: false
            },
            {
                displayName: 'Create Purchase Order',
                name: 'create_purchase_order',
                status: this.getPOStatus.bind(this),
                sref: '.purchase-order',
                permission: 'web.field.administrative.create-purchase-order',
                required: true
            },
            {
                displayName: 'Upload Files',
                status: this.getCount.bind(this, 'image_count'),
                name: 'upload_photos',
                sref: '.upload-photos',
                permission: 'web.field.administrative.upload-photos',
                required: true
            },
            {
                displayName: 'Send Review Request',
                name: 'send_review_request',
                sref: '.reviews.request',
                status: this.getCount.bind(this, 'review_count'),
                permission: 'web.field.administrative.send-review-request',
                required: true
            },
            {
                displayName: 'Tagging',
                name: 'tagged',
                sref: '.tags',
                status: this.getCount.bind(this, 'tag_count'),
                permission: 'web.field.administrative.tagging.view',
                required: false
            },
            {
                displayName: 'Call Source Review Request',
                name: 'send_call_source_review_request',
                sref: '.reviews.call-source',
                status: this.getCount.bind(this, 'callsource_review_count'),
                permission: 'web.field.administrative.call-source-review-request',
                required: true
            },
            {
                displayName: 'Replenish Truck Inventory',
                name: 'replenish_truck_inventory',
                status: this.getReplenishmentStatus.bind(this),
                sref: '.inventory',
                permission: 'web.field.administrative.replenish-truck-inventory',
                required: true
            },
            {
                displayName: 'Replenish Truck Vendor Inventory',
                name: 'vendor_inventory_replenishment',
                status: this.getVendorReplenishmentStatus.bind(this),
                sref: '.vendor-inventory',
                permission: 'web.field.administrative.vendor-inventory',
                required: true,
            },
            {
                displayName: 'Send Invoice and Accounting',
                name: 'send_invoice_accounting',
                status: this.getInvoiceStatus.bind(this),
                sref: '.send-invoice',
                permission: 'web.field.administrative.send-invoice-accounting.page',
                required: true
            }
        ];

        serviceRequestItems: CheckListItem[] = [
            {
                displayName: 'Contact Customer',
                name: 'contact_customer'
            },
            {
                displayName: 'Follow Up Recommendation',
                name: 'follow_up_recommendation'
            },
            {
                displayName: 'Order Supplies',
                name: 'order_supplies'
            },
            {
                displayName: 'Appointment & SR Complete',
                name: 'appointment_service_request_complete',
            }
        ];

        setAppointment(appointment: Appointment) {
            const vm = this;

            vm.appointment = appointment;
            vm.getChecklists();
            vm.getGamification();
        }

        getInvoiceStatus(): string {
            return String(
                Number(this.serviceRequestChecklist['email_on_complete']) +
                Number(this.serviceRequestChecklist['upload_on_complete']) +
                Number(this.appointmentChecklist['close_service_request_on_complete'])
            );
        }

        getVendorReplenishmentStatus(): string {
            if (this.vendorInventoryReplenishmentStatus !== null) {
                return this.vendorInventoryReplenishmentStatus;
            }

            if (!this.vendorInventoryReplenishmentLoading) {
                this.vendorInventoryReplenishmentLoading = true;
                this.VendorInventoryService.getAllReplenishments({ appointment: this.appointment.id, quiet: 1 }).then((resp) => {
                    this.vendorInventoryReplenishmentStatus = "" + resp.data.length;
                    this.vendorInventoryReplenishmentLoading = false;
                });
            }

            return "";
        }

        getReplenishmentStatus(): string {
            if (this.replenishmentStatus !== null) {
                return this.replenishmentStatus;
            }

            if (!this.replenishmentLoading) {
                this.replenishmentLoading = true;
                this.InventoryService.getInventoryReplenishment(this.appointment.id).then((resp) => {
                    this.replenishmentStatus = "" + resp.data.length;
                    this.replenishmentLoading = false;
                });
            }

            return "";
        }

        getCount(propertyName: string): string {
            if (angular.isUndefined(this.serviceRequestChecklist[propertyName])) {
                return '';
            }

            return String(this.serviceRequestChecklist[propertyName]);
        }

        getPOStatus(): string {
            if (this.poStatus !== null) {
                return this.poStatus;
            }

            if (!this.poLoading) {
                this.poLoading = true;
                this.PurchaseOrderService
                    .getAll(this.appointment.service_request.id)
                    .then((resp) => {
                        this.poStatus = "" + resp.data.length;
                        this.poLoading = false;
                    });
            }

            return "";
        }

        upgradeMdlInputs() {
            this.showMdl = false;
            this.$timeout(() => {
                this.showMdl = true;
                this.$timeout(() => {
                    componentHandler.upgradeAllRegistered();
                });
            });
        }

        goTo(sref: string) {
            if (sref === 'zipSolutions.history.recommendations.detail') {
                this.$state.go(sref, {id: this.appointment.service_request.id});
            } else if (sref) {
                this.$state.go(sref);
            }
        }
    }
}